var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVitrificationDataSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_1053)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.1616,
    cy: 12.5581,
    r: 11,
    stroke: "#D3B474"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1615,
    cy: 12.5579,
    r: 7.68138,
    stroke: "#D3B474",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1617,
    cy: 12.5582,
    r: 6.45909,
    stroke: "#D3B474",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1613,
    cy: 14.7934,
    r: 1.61667,
    stroke: "#D3B474",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1945,
    cy: 10.3224,
    r: 1.61667,
    stroke: "#D3B474",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.1618,
    cy: 10.3224,
    r: 1.61667,
    stroke: "#D3B474",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.1281,
    cy: 14.7934,
    r: 1.61667,
    stroke: "#D3B474",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.0951,
    cy: 7.58773,
    r: 0.808333,
    stroke: "#D3B474",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.4681,
    cy: 12.5379,
    r: 0.808333,
    stroke: "#D3B474",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.2284,
    cy: 17.5286,
    r: 0.808333,
    stroke: "#D3B474",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.8553,
    cy: 12.3792,
    r: 0.808333,
    stroke: "#D3B474",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_1053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.161621 0.558105)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitrificationDataSheet);
export default __webpack_public_path__ + "static/media/VitrificationDataSheet.89f5b9d0a4c6600cdc64962d66359000.svg";
export { ForwardRef as ReactComponent };